<div class="toolbox-component" id="text" [class.dark]="isSmallDevice">
  @if (isBoxTitle) {
    <div class="header">
      <div class="header-title">
        <span class="header-title-main">
          {{ 'i18n.toolbox.text.boxTitle' | translate }}
        </span>
      </div>
      <mat-icon svgIcon="close"
        class="close-x"
      (click)="btnCloseClick()"></mat-icon>
    </div>
  }
  @if (!isBoxTitle && !isSmallDevice) {
    <div (click)="btnBackClick()" class="small-header">
      <mat-icon svgIcon="arrow-left"></mat-icon>
        {{ 'i18n.toolbox.text.title' | translate }}
    </div>
  }
  @if (!isBoxTitle && isSmallDevice) {
    <div class="header">
      <div class="header-title">
        <span class="header-title-main">
          {{ 'i18n.toolbox.text.title' | translate }}
        </span>
      </div>
      <mat-icon svgIcon="close"
        class="close-x"
      (click)="btnCloseClick()"></mat-icon>
    </div>
  }
  <div class="content">
    @if (!isSmallDevice) {
      <text-editor
        [isBoxTitle]="isBoxTitle"
        [placeholder]="placeholder"
      ></text-editor>
    }
    @if (isSmallDevice) {
      Platzhalter auf Mobile hier editieren
    }
  </div>
</div>
